import { render, staticRenderFns } from "./renderUploadCustom.vue?vue&type=template&id=6265d25e&"
import script from "./renderUploadCustom.vue?vue&type=script&lang=js&"
export * from "./renderUploadCustom.vue?vue&type=script&lang=js&"
import style0 from "./renderUploadCustom.vue?vue&type=style&index=0&rel=stylesheet%2Fless&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports